"use client";
import { Box, Container, Flex, HStack, Link, Text } from "@chakra-ui/react";
import { FaFacebook } from "react-icons/fa";
import { FaLinkedin, FaThreads } from "react-icons/fa6";
import { useTranslations, useLocale } from "next-intl";
import { IconType } from "react-icons";
import { NextLink } from "@/_components/ui/NextLink";

interface FooterProps {
  theme?: "light" | "dark";
}

export function Footer({ theme = "light" }: FooterProps) {
  const t = useTranslations("landing.footer");
  const locale = useLocale();

  const socialLinks: Array<{ href: string; icon: IconType; name: string }> = [
    {
      href: "https://www.linkedin.com/company/105333473",
      icon: FaLinkedin,
      name: "LinkedIn",
    },
    {
      href: "https://www.facebook.com/profile.php?id=61583867296966",
      icon: FaFacebook,
      name: "Facebook",
    },
    {
      href: "https://www.linkedin.com/company/105333473",
      icon: FaThreads,
      name: "Threads",
    },
  ];

  return (
    <Container maxW={{ base: "full", md: "1400px" }}>
      <Box as="footer" pt={20} pb={4}>
        <Flex direction="row" gap={12} justifyContent="space-between">
          {/* Left: Logo, tagline, social */}
          <Box>
            <Text
              fontWeight="semibold"
              textStyle="2xl"
              fontFamily="heading"
              color={theme === "light" ? "neutral.900" : "white"}
            >
              Knoot.ai
            </Text>
            <Text
              textStyle="sm"
              color={theme === "light" ? "neutral.900" : "white"}
              fontFamily="beVietnamPro"
              letterSpacing="-0.05rem"
              fontWeight="light"
              mb={6}
            >
              {t("tagline")}
            </Text>
            <HStack gap={4}>
              {socialLinks.map(({ href, icon: Icon, name }) => (
                <Link
                  key={name}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={name}
                  border="none"
                  _hover={{
                    textDecor: "none",
                  }}
                >
                  <Box
                    as="span"
                    color={theme === "light" ? "neutral.900" : "white"}
                    transition="all 0.2s ease-in-out"
                    _hover={{ color: "primary.600" }}
                  >
                    <Icon color="inherit" size={24} />
                  </Box>
                </Link>
              ))}
            </HStack>
          </Box>
          {/* Columns */}
          {/* <Grid templateColumns="repeat(4, 1fr)" gap={8} pl={8}>
          <GridItem borderLeft="1px solid" borderColor="neutral.500" pl={8}>
            <Text color="neutral.700" fontWeight="bold" mb={4}>
              Talentify
            </Text>
            <VStack align="flex-start" gap={3}>
              <Link href="#" fontWeight="bold">
                Contact
              </Link>
              <Link href="#" fontWeight="bold">
                Success Stories
              </Link>
              <Link href="#" fontWeight="bold">
                Book A Demo
              </Link>
              <Link href="#" fontWeight="bold">
                Sign-In
              </Link>
              <Link href="#" fontWeight="bold">
                Sign-Up
              </Link>
            </VStack>
          </GridItem>
          <GridItem borderLeft="1px solid" borderColor="neutral.500" pl={8}>
            <Text color="neutral.700" fontWeight="bold" mb={4}>
              Built For
            </Text>
            <VStack align="flex-start" gap={3}>
              <Link href="#" fontWeight="bold">
                Hiring Managers
              </Link>
              <Link href="#" fontWeight="bold">
                Recruiting Teams
              </Link>
              <Link href="#" fontWeight="bold">
                Recruiting Agencies
              </Link>
            </VStack>
          </GridItem>
          <GridItem borderLeft="1px solid" borderColor="neutral.500" pl={8}>
            <Text color="neutral.700" fontWeight="bold" mb={4}>
              Knowledge
            </Text>
            <VStack align="flex-start" gap={3}>
              <Link href="#" fontWeight="bold">
                Blog
              </Link>
              <Link href="#" fontWeight="bold">
                Recruitment Trends Tracker
              </Link>
              <Link href="#" fontWeight="bold">
                How To Hire The Best Talent
              </Link>
              <Link href="#" fontWeight="bold">
                Dictionary For Recruiters
              </Link>
            </VStack>
          </GridItem>
          <GridItem borderLeft="1px solid" borderColor="neutral.500" pl={8}>
            <Text color="neutral.700" fontWeight="bold" mb={4}>
              Compare
            </Text>
            <VStack align="flex-start" gap={3}>
              <Link href="#" fontWeight="bold">
                Moonhub.Ai
              </Link>
              <Link href="#" fontWeight="bold">
                Fetcher
              </Link>
              <Link href="#" fontWeight="bold">
                Loxo
              </Link>
              <Link href="#" fontWeight="bold">
                HireEZ
              </Link>
              <Link href="#" fontWeight="bold">
                LinkedIn Recruiter
              </Link>
              <Link href="#" fontWeight="bold">
                Juicebox
              </Link>
              <Link href="#" fontWeight="bold">
                Gem
              </Link>
              <Link href="#" fontWeight="bold">
                Recruiterflow
              </Link>
              <Link href="#" fontWeight="bold">
                Kula.Ai
              </Link>
              <Link href="#" fontWeight="bold">
                XOPA
              </Link>
              <Link href="#" fontWeight="bold">
                Compare All &gt;
              </Link>
            </VStack>
          </GridItem>
        </Grid> */}
        </Flex>
        {/* Bottom Bar */}
        <Box mt={12} py={6}>
          <Flex
            direction={{ base: "column", md: "row" }}
            justify="space-between"
            align="center"
            gap={4}
          >
            <Text
              color={theme === "light" ? "neutral.900" : "white"}
              textStyle="sm"
              fontFamily="beVietnamPro"
              letterSpacing="-0.05rem"
              fontWeight="light"
            >
              © 2024-2026 Knoot.ai
            </Text>
            <HStack gap={6}>
              <NextLink
                href={`/${locale}/help-center/terms-of-service`}
                color={theme === "light" ? "neutral.500" : "whiteAlpha.500"}
                textStyle="xs"
                _hover={{ color: theme === "light" ? "neutral.900" : "white" }}
              >
                {t("terms_conditions")}
              </NextLink>
              <NextLink
                href={`/${locale}/help-center/privacy-policy`}
                color={theme === "light" ? "neutral.500" : "whiteAlpha.500"}
                textStyle="xs"
                _hover={{ color: theme === "light" ? "neutral.900" : "white" }}
              >
                {t("privacy_policy")}
              </NextLink>
              <NextLink
                href={`/${locale}/help-center/refund-policy`}
                color={theme === "light" ? "neutral.500" : "whiteAlpha.500"}
                textStyle="xs"
                _hover={{ color: theme === "light" ? "neutral.900" : "white" }}
              >
                {t("refund_policy")}
              </NextLink>
            </HStack>
          </Flex>
        </Box>
      </Box>
    </Container>
  );
}
